/**
 * Centralized refetch intervals for React Query polling.
 *
 * Adjust these values to debug performance issues related to background polling.
 * Set any interval to `false` to disable polling for that query.
 */

// Core data
export const REFETCH_AUTH_USER = 10_000
export const REFETCH_ACTIVE_ORG = 10_000
export const REFETCH_ORG_PLAN = 10_000
// The upgrade page shows a deposit as unlocked only once the server's plan
// says so, so it polls faster than the rest of the app.
export const REFETCH_ORG_PLAN_UPGRADE_PAGE = 3_000
export const REFETCH_SMART_ACCOUNTS = 10_000
export const REFETCH_SMART_ACCOUNT = 10_000

// Balances
export const REFETCH_BALANCES = 10_000
// Balance queries scoped to one chainId are slow-moving "is there anything
// here" checks (network discovery, forced-chain swaps), not live balances.
export const REFETCH_SINGLE_CHAIN_BALANCES = 86_400_000 // 24 hours
export const REFETCH_NFT_BALANCES = 20_000

// Transactions & Messages
export const REFETCH_TRANSACTIONS = 10_000
export const REFETCH_MESSAGES = 10_000
export const REFETCH_ASSET_TRANSFERS = 5_000

// Gas & Pricing
export const REFETCH_GAS_ESTIMATES = 30_000
export const REFETCH_SWAP_QUOTE = 10_000
export const REFETCH_ORG_GAS = 60_000

// Compliance
export const REFETCH_ORG_COMPLIANCE = 30_000
export const REFETCH_USER_COMPLIANCE = 10_000

// Token Visibility
export const REFETCH_TOKEN_VISIBILITY = 60_000

// Tokens & Chains
export const REFETCH_TOKENS = 60_000
export const REFETCH_CHAIN_HEALTH = 30_000
export const REFETCH_SIMULATION = 60_000

// Vesting
export const REFETCH_VESTING = 60_000

// Positions
export const REFETCH_POSITIONS = 60_000

// Fiat
export const REFETCH_FIAT = 10_000

// Org networks (needs fast refresh for multi-user editing)
export const REFETCH_ORG_NETWORKS = 5_000

// Account imports (short-lived progress view over a minutes-long job)
export const REFETCH_ACCOUNT_IMPORT_JOBS = 3_000

// Imported accounts list, while any import is still indexing
export const REFETCH_IMPORTED_ACCOUNTS_INDEXING = 15_000

// Lot recompute (progress strip over a minutes-long rebuild). The idle cadence
// covers a queued job, which has no progress to show yet.
export const REFETCH_LOT_RECOMPUTE_JOB = 3_000
export const REFETCH_LOT_RECOMPUTE_JOB_IDLE = 15_000

// Agent login
// A guess: a tab left open learns of a decision made elsewhere within seconds.
export const REFETCH_AGENT_LOGIN_REQUEST = 3_000
